import { useRef, useCallback, useEffect } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
function useTimeout(delay) {
  var timerRef = useRef();
  var executeFunction = useCallback(function (fn) {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(function () {
      fn();
    }, delay !== null && delay !== void 0 ? delay : 0);
  }, [delay]);
  useEffect(function () {
    return function () {
      timerRef.current && clearTimeout(timerRef.current);
    };
  }, []);
  return executeFunction;
}

export default useTimeout;
//# sourceMappingURL=use-timeout.esm.js.map
